import { Currency } from '@/core/currency/interfaces';

const PEN: Currency = {
    name: 'Peruvian Sol',
    demonym: 'Peruvian',
    majorSingle: 'Sol',
    majorPlural: 'Soles',
    codeNumeric: '604',
    symbol: 'S/.',
    symbolNative: 'S/.',
    minorSingle: 'Céntimo',
    minorPlural: 'Céntimos',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'PEN',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default PEN;
